export default __webpack_public_path__ + "static/media/Insert_Text_Return.b12db77a.svg";